import { dataMember, required, typedArray } from 'santee-dcts';
import { EQueryStatus } from './e-query-status';
import {EQueryCCQuestion} from '../../admin/e-query/models/e-query-c-c-question';
import { Distance } from '../../shared';

export class EQueryInfo {
    @dataMember()
    @required()
    public eQueryId: number;

    @dataMember()
    @required({nullable: true})
    public statusName: EQueryStatus;

    @dataMember()
    @required({ nullable: true })
    public eQueryAge: Distance;

    @dataMember()
    @required({nullable: true})
    public commentText: string;

    @dataMember()
    @required()
    public shouldBeResponded: boolean;
}
